<template>
  <div>
    <div class="tablet:px-4 mobile:px-0 pb-10">
      <!-- Loading Indicator -->
      <div v-if="isLoading" class="flex justify-center items-center h-40">
        <VueSpinnerIos size="40px" />
      </div>

      <!-- 404 Error Message -->
      <div
        v-else-if="isNotFound"
        class="w-full h-screen flex flex-col gap-3 items-center justify-center text-center pb-24"
      >
        <p class="text-5xl font-semibold text-red-500">مخاطب یافت نشد :(</p>
        <p class="text-sm text-gray-500">
          لطفاً از وجود اطلاعات مطمئن شوید و دوباره تلاش کنید.
        </p>
        <router-link
          to="/leads"
          class="mt-4 px-4 py-2 bg-blue-primary text-white rounded-lg hover:bg-blue-primary-darker"
        >
          بازگشت به صفحه لید ها
        </router-link>
      </div>

      <!-- Content -->
      <div v-else class="">
        <div
          class="flex mt-8 w-full gap-4 mobile:flex-col mobile:px-4 mobile:text-sm"
        >
          <div class="flex flex-col w-[65%] mobile:w-full flex-wrap gap-4">
            <div class="flex w-full gap-4 items-center">
              <div class="flex flex-col gap-2 w-full">
                <label for="name">نام:</label>
                <input
                  type="text"
                  name="name"
                  v-model="name"
                  disabled="true"
                  class="input w-full h-12 cursor-not-allowed"
                />
              </div>
              <div class="flex flex-col gap-2 w-full">
                <label for="phone">شماره تلفن:</label>
                <input
                  type="text"
                  name="phone"
                  v-model="phone"
                  disabled="true"
                  class="input w-full h-12 cursor-not-allowed"
                />
              </div>
            </div>

            <div class="w-full flex gap-2 mobile:flex-col">
              <div class="flex flex-col gap-2 basis-full mobile:w-full">
                <label for="bussinessPhone">تلفن کاری:</label>
                <input
                  type="text"
                  name="bussinessPhone"
                  v-model="bussinessPhone"
                  class="input w-full h-12"
                />
              </div>
              <div class="flex flex-col gap-2 basis-full mobile:w-full">
                <label for="bussinessEmail">ایمیل کاری:</label>
                <input
                  type="text"
                  name="bussinessEmail"
                  v-model="bussinessEmail"
                  class="input w-full h-12"
                />
              </div>
            </div>

            <div class="w-full flex gap-2 mobile:flex-col">
              <div class="flex flex-col gap-2 basis-full mobile:w-full">
                <label for="initialInsta">اینستاگرام اولیه:</label>
                <input
                  type="text"
                  name="initialInsta"
                  v-model="initialInsta"
                  class="input w-full h-12"
                />
              </div>
              <div class="flex flex-col gap-2 basis-full mobile:w-full">
                <label for="connectedInsta">اینستاگرام وصل شده:</label>
                <input
                  type="text"
                  name="connectedInsta"
                  v-model="connectedInsta"
                  class="input w-full h-12"
                />
              </div>
            </div>

            <div class="w-full flex gap-2 mobile:flex-col">
              <div class="flex flex-col gap-2 basis-full">
                <label for="instaConnectionDate"
                  >تاریخ وصل کردن اینستاگرام:</label
                >
                <input
                  type="text"
                  name="instaConnectionDate"
                  v-model="instaConnectionDate"
                  class="input w-full h-12"
                />
              </div>
              <div class="flex flex-col gap-2 basis-full">
                <label for="registrationDate">تاریخ رجیستر شدن:</label>
                <input
                  type="text"
                  name="registrationDate"
                  v-model="registrationDate"
                  class="input w-full h-12"
                />
              </div>
            </div>

            <div class="w-full flex flex-col gap-2">
              <label for="reagent">معرف:</label>
              <input
                type="text"
                name="reagent"
                v-model="reagent"
                class="input w-full h-12"
              />
            </div>
            <SmsLogTable class="w-full" :phone="contact.phone" />
            <button
              @click="handleSubmit"
              class="mt-8 w-32 rounded-lg bg-blue-primary text-white p-2 transition-colors hover:bg-blue-primary-darker mobile:w-full mobile:mt-2 mobile:py-4"
            >
              ذخیره اطلاعات
            </button>
          </div>
          <div class="w-[35%] flex flex-col gap-2 mobile:w-full mobile:mt-8">
            <div
              class="w-full bg-yellow-200 text-orange-500 text-center py-2 rounded-lg"
            >
              جدیدترین لید
            </div>
            <ContactLead v-if="firstLead" :lead="firstLead" />
            <div class="flex flex-col gap-2" v-if="isLeadsOpen">
              <ContactLead
                v-for="lead in archivedLeads"
                :key="lead.id"
                :lead="lead"
              />
            </div>
            <button
              v-if="archivedLeads?.length > 0"
              class="w-full bg-white border my-2 text-gray-500 text-center py-2 rounded-lg transition-colors hover:bg-slate-200 hover:text-black cursor-pointer"
              @click="isLeadsOpen = !isLeadsOpen"
            >
              {{
                isLeadsOpen ? "فقط جدیدترین رو نشون بده" : "نمایش همه ی لید ها"
              }}
            </button>
            <div class="flex flex-col gap-2" v-if="allNotes">
              <NoteTemplate
                v-for="note in allNotes"
                :key="note.id"
                :note="note"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { getConatctData } from "@/services/api/apiServiceContacts";
import { computed, onMounted, ref } from "vue";
import ContactLead from "@/components/contacts/ContactLead.vue";
import { useToast } from "vue-toastification";
import { useMutation } from "@tanstack/vue-query";
import { updateContact } from "@/services/api/apiServiceContacts";
import Swal from "sweetalert2";
import { useStore } from "vuex";
import NoteTemplate from "@/components/ui/modalContents/NoteTemplate.vue";
import { VueSpinnerIos } from "vue3-spinners";
import SmsLogTable from "@/components/leads/SmsLogTable.vue";

const store = useStore();

const contactId = computed(() => store.state.contactsSlice.selectedContactId);
// Route Params
const toast = useToast();
const { mutate } = useMutation({
  mutationFn: updateContact,
  onSuccess: () => {
    Swal.fire({
      icon: "success",
      title: "مخاطب با موفقیت به روز شد.",
      showConfirmButton: false,
      timer: 1500,
    });
  },
  onError: () => {
    Swal.fire({
      icon: "error",
      title: "به روز رسانی مخاطب با خطا مواجه شد!",
      showConfirmButton: false,
      timer: 1500,
    });
  },
});
const contact = ref(null);
const leads = ref(null);
const firstLead = ref(null);
const archivedLeads = ref(null);
const remainingNullLeads = ref([]);
const allNotes = computed(() => {
  return leads?.value?.reduce((accumulator, lead) => {
    return accumulator.concat(lead.notes || []);
  }, []);
});
// Input Refs
const name = ref("");
const phone = ref("");
const bussinessPhone = ref("");
const bussinessEmail = ref("");
const initialInsta = ref("");
const connectedInsta = ref("");
const instaConnectionDate = ref("");
const registrationDate = ref("");
const reagent = ref("");
const isLeadsOpen = ref(false);

// isLoading State
const isLoading = ref(true);
const isNotFound = ref(false); // New state for 404 error

// Fetch Contact Data
const fetchContactData = async () => {
  try {
    const response = await getConatctData(contactId.value);
    contact.value = response;
    firstLead.value = await getFirstLead(response?.leads);
    // leads.value = sortByCreatedAtDesc(response?.leads);
    leads.value = response?.leads;
    archivedLeads.value = removeFirstLeadFromArray(leads?.value);
    mapContactToRefs(response);
  } catch (err) {
    if (err.response && err.response.status === 404) {
      // Handle 404 error
      isNotFound.value = true;
    } else {
      console.error("Error fetching contact data:", err);
      toast.error("مشکلی در بارگذاری اطلاعات مخاطب به وجود آمد.");
    }
  } finally {
    isLoading.value = false;
  }
};
function getFirstLead(leadsArray) {
  const targetLeads = leadsArray.filter((lead) => lead.is_won === null);

  if (targetLeads?.length > 1) {
    remainingNullLeads.value = targetLeads.slice(1);
  }

  return targetLeads[0];
}

// function sortByCreatedAtDesc(array) {
//   return array.sort(
//     (a, b) =>
//       new Date(b.updated_at || b.created_at) -
//       new Date(a.updated_at || a.created_at),
//   );
// }

const removeFirstLeadFromArray = (array) => {
  const archived = array.filter((lead) => lead.is_won !== null);
  return [...remainingNullLeads.value, ...archived];
};

// Map Contact Data to Refs
const mapContactToRefs = (contact) => {
  name.value = contact.name || "";
  phone.value = contact.phone || "";

  // Map attribute_values to refs
  contact.attribute_values.forEach((attr) => {
    switch (attr.attribute.name) {
      case "تلفن کاری":
        bussinessPhone.value = attr.value || "";
        break;
      case "ایمیل کاری":
        bussinessEmail.value = attr.value || "";
        break;
      case "اینستاگرام اولیه":
        initialInsta.value = attr.value || "";
        break;
      case "اینستاگرام وصل شده":
        connectedInsta.value = attr.value || "";
        break;
      case "تاریخ وصل کردن اینستاگرام":
        instaConnectionDate.value = attr.value || "";
        break;
      case "تاریخ رجیستر کردن":
        registrationDate.value = attr.value || "";
        break;
      case "معرف":
        reagent.value = attr.value || "";
        break;
      default:
        break;
    }
  });
};

function handleSubmit() {
  const payload = {
    attribute_values: {
      1: bussinessPhone.value || "",
      2: bussinessEmail.value || "",
      3: initialInsta.value || "",
      4: connectedInsta.value || "",
      5: instaConnectionDate.value || "",
      6: registrationDate.value || "",
      8: reagent.value || "",
    },
  };

  mutate({ contactId: contactId.value, payload });
}

// Fetch Data on Mount
onMounted(async () => {
  await fetchContactData();
});
</script>
